export enum AppealType {
  UnderpaidProvider,
  OverpaidProvider,
  NA,
  PayAfterDenial,
}
